import Component from './direct_message_queues_targets.vue'
export default Component
